import { styled } from '@mui/material';

export const Wrapper = styled('div')({
  '& label': {
    marginTop: 12,
  },
});
